export var linearAnimation = function linearAnimation(_a) {
  var onProgress = _a.onProgress,
      _b = _a.onIdUpdate,
      onIdUpdate = _b === void 0 ? function () {} : _b,
      time = _a.time,
      _c = _a.initialProgress,
      initialProgress = _c === void 0 ? 0 : _c;

  if (time === 0) {
    onProgress(1);
    onIdUpdate(null);
    return;
  }

  var start = null;

  var step = function step(timestamp) {
    if (!start) start = timestamp;
    var progress = Math.min((timestamp - start) / time + initialProgress, 1);
    onProgress(progress);

    if (progress < 1) {
      onIdUpdate(window.requestAnimationFrame(step));
    } else {
      onIdUpdate(null);
    }
  };

  onIdUpdate(window.requestAnimationFrame(step));
};
//# sourceMappingURL=linear-animation.js.map